import { Delete } from 'ui/icons/action/Delete';
import { MakeCopy } from 'ui/icons/action/MakeCopy';
import { ActionButtonContainer, StyledCoreButton } from './ActionButtons.styled';

type Props = {
  /** Additional classes for buttons. */
  buttonClassName: string;
  /** If the delete button is visible. */
  canDelete: boolean;
  /** Additional Classes */
  className: string;
  /** Copy tooltip text. */
  copyText: string;
  /** Delete tooltip text. */
  deleteText: string;
  /** If the action buttons are group actions. */
  isGroupActionButtons?: boolean;
  /** Callback function when copy button is clicked. e isn't used, need to refactor out */
  onCopy: (e: Record<string, never>, buttonProps: Record<string, any>) => void;
  /** Callback function when delete button is clicked. */
  onDelete: (e: Record<string, never>, buttonProps: Record<string, any>) => void;
  /** Display button borders. */
  showBorders: boolean;
  /** Use trash icon for delete. */
  trashIconDelete: boolean;
};

const ActionButtons = ({
  buttonClassName,
  className,
  canDelete = true,
  copyText = 'Copy',
  deleteText = 'Delete',
  isGroupActionButtons = false,
  onCopy,
  onDelete,
  showBorders = false,
}: Props) => (
  <ActionButtonContainer isGroupActionButtons={isGroupActionButtons} className={className}>
    <StyledCoreButton
      data-test="action-button-make-copy"
      $showBorders={showBorders}
      pill={!showBorders}
      table={showBorders}
      className={buttonClassName}
      onClick={onCopy}
      title={copyText}
    >
      <MakeCopy height={16} width={16} />
    </StyledCoreButton>
    {canDelete && (
      <StyledCoreButton
        data-test="action-button-delete"
        $showBorders={showBorders}
        pill={!showBorders}
        table={showBorders}
        className={buttonClassName}
        onClick={onDelete}
        title={deleteText}
      >
        <Delete height={16} width={16} />
      </StyledCoreButton>
    )}
  </ActionButtonContainer>
);

export default ActionButtons;
